import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import Icons from 'components/icons';
import { Localize } from 'components/service';


const StandsGlobalMaterialsField = ({ stand }) => {

    const fileListItem = [
        {
            field: 'file_stand_plan',
            label: <Localize>ACTIONS.List_Item_Label_StandPlan</Localize>,
        },
        {
            field: 'file_graphic',
            label: <Localize>ACTIONS.List_Item_Label_Graphic</Localize>,
        },
        {
            field: 'file_info',
            label: <Localize>ACTIONS.List_Item_Label_Info</Localize>,
        },
        {
            field: 'file_photo',
            label: <Localize>ACTIONS.List_Item_Label_Photo</Localize>,
        }
    ]
        .filter(({ field }) => stand?.[ field ])
        .map(({ field, label }) => {
            const fileName = stand?.[ field ]?.split('/')?.pop()?.split('~')?.pop();

            return (
                <li key={ field }>
                    <div className='download-file'>
                        <Tooltip overlayClassName="craft-tooltip" destroyTooltipOnHide={ true } title={ fileName }>
                            <Link
                                to='#'
                                onClick={ () => {
                                    window.open(
                                        stand?.[ field ],
                                        '_blank'
                                    );
                                } }
                            >
                                <Icons.Download /> <span className='link-text'>{ label }</span>
                            </Link>
                        </Tooltip>
                    </div>
                </li>
            )
        });

    return (
        fileListItem.length ?
            <ul className='download-file-list'>
                { fileListItem }
            </ul>
            :
            <strong>&mdash;</strong>
    );
};

export default StandsGlobalMaterialsField;
